const MOUSE_FLOW_EVENT = {
  NAME: "activateFeedback",
  ID: "GYUkZx5TtU-8RHKfvLcJKQ",
};

const DEFAULT_SCROLL_VALUE = 0;

const SIZE_NOT_AVAILABLE = "not-available";

export { SIZE_NOT_AVAILABLE, MOUSE_FLOW_EVENT, DEFAULT_SCROLL_VALUE };
